/* React */
import React from "react";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { setIsScrolling } from "src/redux/features/scrolling/scrollSlice";

/* Ionic */
import { IonContent } from "@ionic/react";

/* Components */
import InsightsMenu from "src/components/menus/insights-menu/InsightsMenu";
import EmptyDataContainer from "src/components/insights/empty-data-container/EmptyDataContainer";

/* Stylesheet */
import styles from "./InsightsPageWrapper.module.scss";

/* Interfaces */
interface InsightsPageWrapperProps {
  children: React.ReactNode;
}

const InsightsPageWrapper: React.FC<
  InsightsPageWrapperProps
> = ({ children }) => {
  const dispatch = useDispatch();

  const insightsFilterState = useSelector(
    (state: RootState) => state.insightsFilter
  );
  const { mainCondition } = insightsFilterState;

  const secondaryMenuState = useSelector(
    (state: RootState) => state.secondaryMenu
  );

  const { isDisabled } = secondaryMenuState;

  const handleScroll = () => {
    dispatch(setIsScrolling(true));

    setTimeout(() => {
      dispatch(setIsScrolling(false));
    }, 300);
  };

  if (mainCondition.isLoading) {
    return <div />;
  }

  return !isDisabled ? (
    <div className={styles.insights_page_wrapper}>
      <div className={styles.insights_menu_container}>
        <InsightsMenu />
      </div>
      <IonContent
        className={styles.content}
        scrollEvents={true}
        onIonScroll={handleScroll}
      >
        {children}
      </IonContent>
    </div>
  ) : (
    <EmptyDataContainer />
  );
};

export default InsightsPageWrapper;
